import React from 'react'
import { connect } from 'react-redux'
import firebase from 'firebase/app'
import moment from 'moment'
import TextareaAutoSize from 'react-textarea-autosize'
import { Icon, Popup, Button, Form, Segment, Label, Table, List } from 'semantic-ui-react'
import { capitalize, sumBy, map, get, size, reduce } from 'lodash'

import utils from '../../../../utils'

class ItemsCell extends React.PureComponent {
  state = {
    visible: false,
    loading: false,
    sending: false,
  }

  callMerchantToAcceptOrder = orderPhoneNumbers => {
    if (!orderPhoneNumbers) return null

    try {
      const { order } = this.props
      const isOrdering = order.item_order_status === 'ordering'

      if (order.notified_partner.push_notification_count >= 3 && isOrdering) {
        const splittedPhones = orderPhoneNumbers.split(/\s*[,|/]\s*/)
        const merchantPhone = splittedPhones[0].replace(/\D/g, '').replace(/^(855|0|8550)/, '+855')

        const callable = firebase.app().functions('asia-northeast1').httpsCallable('createAutoCall')
        callable({ orderKey: order.key , merchantPhone })
      }

      return null
    } catch (error) {
      alert(error.message || error)
    }

    return null
  }

  onUpdateNotifyCount = async result => {
    try {
      const { order } = this.props
      const pushNotificationCount = get(order, 'notified_partner.push_notification_count', 0)
      const orderPhoneNumbers = get(order, 'restaurant.branch.order_phone', null)

      const updates = {}

      if (result.data.status === 'OK') {
        const { responses, successCount, failureCount } = result.data.response

        updates[`orders/${order.key}/notified_partner`] = {
          notifyCount: size(responses),
          successCount,
          failureCount,
          sentAt: Date.now(),
          push_notification_count: pushNotificationCount + 1,
        }
      } else {
        updates[`orders/${order.key}/notified_partner`] = {
          notifyCount: 0,
          successCount: 0,
          failureCount: 0,
          sentAt: Date.now(),
          push_notification_count: pushNotificationCount + 1,
        }
      }

      const err = await firebase
        .database()
        .ref()
        .update(updates)

      if (err) throw err

      // to give time to merchant response to order after notification push
      setTimeout(() => {
        this.callMerchantToAcceptOrder(orderPhoneNumbers)
      }, 6000)
    } catch (error) {
      alert(error.message || error)
    }
  }

  onNotifyPartner = async () => {
    try {
      const { order } = this.props

      this.setState({ sending: true, visible: false })

      const params = {
        branchUid: order.restaurant.branch.key,
        orderUid: order.key,
      }

      const functions = firebase.app().functions('asia-northeast1').httpsCallable('orderAction')

      const result = await functions({ actionType: 'notify-partner-order', ...params })

      this.setState({ sending: false }, () => this.onUpdateNotifyCount(result))
    } catch (error) {
      this.setState({ sending: false })
      alert(error.message || error)
    }
  }

  onOrderingStatusClick = async orderingStatus => {
    const { operator, order } = this.props

    try {
      this.setState({ loading: true, visible: false })

      const params = {
        branchUid: order.restaurant.branch.key,
        orderUid: order.key,
        operator: operator.username,
        orderingStatus,
      }

      const functions = firebase
        .app()
        .functions('asia-northeast1')
        .httpsCallable('orderAction')

      await functions({ actionType: 'update-ordering-status', ...params })

      this.setState({ loading: false }, () => {
        if (orderingStatus === 'ordering') {
          this.onNotifyPartner()
        }
      })
    } catch (error) {
      this.setState({ loading: false })
      alert(error.message || error)
    }
  }

  getItemPrice =({ item, itemDiscountKey}) => {
    const optionsAmount = reduce(
      item.options,
      (result, option) => {
        map(option.selected_choices, choice => {
          // eslint-disable-next-line no-param-reassign
          result += Number(choice.price)
        })

        return result
      },
      0
    )

    const itemDiscountRate = this.getItemDiscountRate({item, itemDiscountKey})

    const currentPrice = item.price_at_order
    const discountRate = Number(itemDiscountRate.discountRate  || 0)
    const itemOptionDiscountPrice = Number(optionsAmount * (1 - discountRate / 100))
    const currentPriceWithOptions = Number(parseFloat(currentPrice + optionsAmount).toFixed(2))
    const currentDiscountedPrice = Number(parseFloat(currentPrice * (1 - discountRate / 100)).toFixed(2))
    const currentDiscountPriceWithOptions =  Number(parseFloat(currentDiscountedPrice + itemOptionDiscountPrice).toFixed(2))

    return {
      currentPrice,
      optionsAmount,
      currentDiscountedPrice,
      currentPriceWithOptions,
      currentDiscountPriceWithOptions,
    }
  }

  getItemDiscountRate = ({item, itemDiscountKey }) => {
    let discountRate = 0

    if(itemDiscountKey[item.item_key]) {
      const itemDiscountRate = itemDiscountKey[item.item_key]
      discountRate = itemDiscountRate
    }

    return {
      discountRate
      }
  }

  onOrderActionsClick = () => {
    const { visible } = this.state

    this.setState({ visible: !visible })
  }

  renderItemSpecialNote = item =>
    <Segment style={{ margin: 3, padding: 0 }} color="green">
      <Form>
        <TextareaAutoSize readOnly rows={1} minRows={1} value={item.special_note} />
      </Form>
    </Segment>

  renderItems = () => {
    const { order } = this.props
    const { items } = order
    const suffixColor = { color: 'rgba(208, 62, 62, 1)' }
    const prefixColor = { color: 'green' }
    const disabledColor = { color: 'silver' }
    const optionPriceColor = { color: 'orange' }
    const textDecoration = { textAlign: 'center', fontSize: 14, margin: 0, marginBottom: 5, textDecorationLine: 'line-through' , textDecorationColor: 'silver' }
    const itemDiscountKey = get(order,'restaurant.branch.discount.items', 0)

    return map(items, (item, itemKey) => {
      const isHasNote = item.special_note && item.special_note.length > 0
      const hasDiscount = itemDiscountKey[item.item_key]
      const itemPrice = this.getItemPrice({item, itemDiscountKey})

      const options = []
      const prefixs = []
      const suffixs = []

      map(item.options || {}, option => {
        map(option.selected_choices, (choice, choiceKey) => {
          let color = {}

          if (option.is_prefix) {
            prefixs.push(choice.name)
            color = disabledColor
          } else if (option.is_suffix) {
            suffixs.push(choice.name)
            color = disabledColor
          }

          options.push(
            <li key={choiceKey} style={{ fontSize: 12, margin: 0, ...color }}>
              {`${option.option_name}: ${choice.name}`}
              {choice.price > 0 ? (
                <span style={optionPriceColor}>{` + (${parseFloat(choice.price).toFixed(2)}$)`}</span>
              ) : null}
            </li>
          )
        })
      })

      return (
        <List.Item key={itemKey}>
          <div className="order-item-list-name-wrapper">
            <div className="order-item-list-qty">
              <Label style={{ fontSize: 15 }} circular>
                {item.quantity} x
              </Label>
            </div>

            <div className="order-item-list-name">
              <span>
                {prefixs.length > 0 ? <span style={prefixColor}>{prefixs.join(' ')}</span> : null}
                {` ${item.name} `}
                {suffixs.length > 0 ? <span style={suffixColor}>{suffixs.join(' ')}</span> : null}
              </span>
              {
                item.code ?
                  <div style={{ color: 'grey', fontWeight: 'bold', fontSize: 13 }}>
                  {`Code: ${item.code}`}
                  </div>
                : null
              }
              <ul style={{ marginBottom: 0, marginTop: 5, paddingLeft: 20 }}>{options}</ul>
            </div>

            <div style={{flexDirection: 'column'}} className="order-item-list-price">
              {hasDiscount ?
                <Label style={textDecoration}>
                  <span style={{color: 'silver'}}>
                  $ {itemPrice.currentPrice}
                  </span>
                  {itemPrice.optionsAmount > 0 ? (
                  <span style={{color: 'silver'}}>{` / $ ${itemPrice.currentPriceWithOptions}`}</span>
                  ) : null}
                </Label> : null
              }
              <Label style={{ fontSize: 14, textAlign: 'center', margin: 0 }}>
                $ {itemPrice.currentDiscountedPrice}
                {itemPrice.optionsAmount > 0 ? (
                  <span style={optionPriceColor}>{` / $ ${itemPrice.currentDiscountPriceWithOptions}`}</span>
                ) : null}
              </Label>
            </div>

          </div>

          {isHasNote && this.renderItemSpecialNote(item)}
        </List.Item>
      )
    })
  }

  renderOrderingButton = () => {
    const { order, readOnly } = this.props
    const { visible, loading } = this.state

    const isOrdered = order.item_order_status === 'ordered'
    const isOrdering = order.item_order_status === 'ordering'

    let label = 'Not yet'
    let color = 'red'

    if (isOrdering) {
      label = 'Ordering'
      color = 'orange'
    } else if (isOrdered) {
      label = 'Ordered'
      color = 'green'
    }

    return (
      <Popup
        wide
        on="click"
        hideOnScroll
        open={visible}
        position="bottom center"
        onOpen={this.onOrderActionsClick}
        onClose={this.onOrderActionsClick}
        trigger={
          <Button loading={loading} disabled={loading} style={{ margin: 0 }} size="mini" color={color}>
            {label}
          </Button>
        }
      >
        <div style={{ marginBottom: 3 }}>
          <Button
            fluid
            size="tiny"
            onClick={() => this.onOrderingStatusClick('ordering')}
            disabled={isOrdering || readOnly}
          >
            Ordering
          </Button>
        </div>

        <div>
          <Button
            fluid
            size="tiny"
            onClick={() => this.onOrderingStatusClick('ordered')}
            disabled={isOrdered || readOnly}
          >
            Ordered
          </Button>
        </div>
      </Popup>
    )
  }

  renderItemActions = () => {
    const { order, readOnly, showEditItems } = this.props

    const allItemsCount = order.items ? sumBy(Object.values(order.items), 'quantity') : 0
    const isEditable =
      order.status !== 'rejected' && order.status !== 'delivered' && !order.driver_pending_order && !readOnly
    const isEnabledOrdering = order.status !== 'rejected' && order.status !== 'delivered' && !readOnly

    return (
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Label>All Items: {allItemsCount}</Label>
        <div>
          <Button
            size="mini"
            disabled={!isEditable}
            onClick={showEditItems}
            style={{ margin: 0, marginRight: 5 }}
          >
            Edit
          </Button>

          {isEnabledOrdering && this.renderOrderingButton()}
        </div>
      </div>
    )
  }

  onResendClick = () => {
    const { order, readOnly } = this.props
    const isAcceptedByPartner = Boolean(order.accepted_by_partner)

    if (isAcceptedByPartner || readOnly) return false

    return this.onNotifyPartner()
  }

  renderNotification = () => {
    const { order, readOnly } = this.props
    const { sending } = this.state
    const isAcceptedByPartner = Boolean(order.accepted_by_partner)

    if (order.status === 'rejected' || order.status === 'delivered') return null

    if (sending)
      return (
        <React.Fragment>
          Sending
          <Icon color="grey" style={{ marginLeft: 3 }} name="spinner" loading={sending} />
        </React.Fragment>
      )

    if (order.notified_partner)
      return (
        <div style={{ fontSize: 13 }}>
          <div>
            Notified {order.notified_partner.successCount}/{order.notified_partner.notifyCount}
          </div>
          <div>{moment(order.notified_partner.sentAt).fromNow()}</div>
          <div>Push Notification: {order.notified_partner.push_notification_count}</div>
          <div>
            Resend
            <Icon
              color="green"
              name="repeat"
              onClick={this.onResendClick}
              disabled={isAcceptedByPartner || readOnly}
              style={{ marginLeft: 3, cursor: 'pointer' }}
            />
          </div>
        </div>
      )

    return null
  }

  renderOperator = () => {
    const { order } = this.props
    const isOrdered = order.item_order_status === 'ordered'
    const isOrdering = order.item_order_status === 'ordering'

    let textToDisplay = ''
    let operator = ''
    let createdAt = null

    if (order.status === 'rejected') return null

    if (isOrdering) {
      createdAt = order.ordering_at
      textToDisplay = `Ordering by OPT`
      operator = `(${order.ordering_by_operator})`
    } else if (isOrdered) {
      createdAt = order.ordered_at

      if (order.ordered_by_operator) {
        textToDisplay = `Ordered by OPT`
        operator = `(${order.ordered_by_operator})`
      } else if (order.accepted_by_partner) {
        if (order.accepted_by_partner.includes('Muuver:')) {
          textToDisplay = `Ordered by Muuver`
          operator = `(${order.accepted_by_partner})`
        } else {
          textToDisplay = `Accepted by Partner`
          operator = `(${order.accepted_by_partner})`
        }
      }
    }

    return (
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 5}}>
        <div>{this.renderNotification()}</div>

        <div style={{ textAlign: 'right', fontSize: 13 }}>
          <div>{textToDisplay}</div>
          <div>{operator}</div>
          {createdAt && <div>{moment(createdAt).fromNow()}</div>}
        </div>
      </div>
    )
  }

  render() {
    const { order } = this.props
    const orderNumber = utils.order.getOrderNumber(order)

    const unavailableOption = order.item_unavailable_option
    let unavailableOptionLabel = ''

    if (unavailableOption && unavailableOption !== 'contact_me') {
      unavailableOptionLabel = capitalize(unavailableOption.replace(/_/g, ' '))
    } else {
      unavailableOptionLabel = 'Call Customer'
    }

    return (
      <Table.Cell className="list-item-cell">
        <List divided verticalAlign="middle" style={{ marginBottom: 10 }}>
          <List.Item style={{ marginBottom: 5 }}>
            <List.Header>Order Number: {orderNumber}</List.Header>
              <List.Header style={{ marginTop: 5, fontSize: 12, color: '#FF7139' }}>
                If items unavailable: {unavailableOptionLabel}
              </List.Header>
          </List.Item>

          {this.renderItems()}
        </List>

        <hr style={{ margin: 0, marginBottom: 10 }} />

        {this.renderItemActions()}
        {this.renderOperator()}
      </Table.Cell>
    )
  }
}

const mapState = ({ auth }) => ({
  operator: auth.data,
})

export default connect(mapState)(ItemsCell)



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/ItemsCell.js